import AdminArea from "@/src/components/admin-area/AdminArea.vue";
import AdminDashboard from "@/src/components/admin-area/AdminDashboard.vue";
import RoleIndex from "@/src/components/admin-area/roles/RoleIndex.vue";
import MembershipCategoryIndex from "@/src/components/admin-area/memberships-categories/MembershipCategoryIndex.vue";
import MembershipCategoryEdit from "@/src/components/admin-area/memberships-categories/MembershipCategoryEdit.vue";
import TroubleshootDonors from "@/src/components/admin-area/troubleshoot/donors/TroubleshootDonors.vue";
import TroubleshootMatches from "@/src/components/admin-area/troubleshoot/matches/TroubleshootMatches.vue";
import TroubleshootRobocallReduction from "@/src/components/admin-area/troubleshoot/robocall/TroubleshootRobocallReduction.vue";
import TemplateCategoryEdit from '@/src/components/admin-area/templates/TemplateCategoryEdit.vue';
import TemplateCategoryEditAdvanced from '@/src/components/admin-area/templates/TemplateCategoryEditAdvanced.vue';
import TemplateCategoryIndex from '@/src/components/admin-area/templates/TemplateCategoryIndex.vue';
import TemplateEdit from '@/src/components/admin-area/templates/TemplateEdit.vue';
import TemplateEditAdvanced from '@/src/components/admin-area/templates/TemplateEditAdvanced.vue';
import TemplateIndex from '@/src/components/admin-area/templates/TemplateIndex.vue';
import UserIndex from "@/src/components/admin-area/users/UserIndex.vue";
import UserEdit from "@/src/components/admin-area/users/UserEdit.vue";
import UserEditTeams from "@/src/components/admin-area/users/UserEditTeams.vue";
import UserEditAdvanced from "@/src/components/admin-area/users/UserEditAdvanced.vue";
import TeamIndex from "@/src/components/admin-area/teams/TeamIndex.vue";
import TeamEdit from '@/src/components/admin-area/teams/TeamEdit.vue';
import TeamEditManage from '@/src/components/admin-area/teams/TeamEditManage.vue';
import TeamEditAdvanced from '@/src/components/admin-area/teams/TeamEditAdvanced.vue';
import ManageGroupIndex from '@/src/components/admin-area/teams/groups/ManageGroupIndex.vue';
import ManageGroupEdit from '@/src/components/admin-area/teams/groups/ManageGroupEdit.vue';
import ARORulesIndex from "@/src/components/admin-area/aro-rules/ARORulesIndex.vue";
import ARORulesEdit from '@/src/components/admin-area/aro-rules/ARORulesEdit.vue';
import RobocallReductionsEdit from '@/src/components/admin-area/application-settings/robocall-reductions/RobocallReductionsEdit.vue';
import ManageRobocallNotifications from '@/src/components/admin-area/application-settings/robocall-reductions/ManageRobocallNotifications.vue';
import { useAppCoreStore } from "@/src/stores/app-core";
import ProcedureNotesIndex from "@/src/components/admin-area/procedure-notes/ProcedureNotesIndex.vue";
import ProcedureNotesEdit from '@/src/components/admin-area/procedure-notes/ProcedureNotesEdit.vue';
import ImportUsers from "@/src/components/admin-area/import-users/ImportUsers.vue";
import RoleEdit from "@/src/components/admin-area/roles/RoleEdit.vue";
import { adminIntegrationRoutes } from "./admin/integration-routes";
import { adminFinalizedOffersCSVRoutes } from "./admin/unos-finalized-offers-csv-routes";
import MonthlyBusinessReportSet from "../components/admin-area/reports/MonthlyBusinessReportSet.vue";
import { PermissionNames } from "@/src/enums";
import OrganIndex from '@/src/components/admin-area/application-settings/organs/OrganIndex.vue';
import OrganGroupIndex from '@/src/components/admin-area/application-settings/organ-groups/OrganGroupIndex.vue';
import OrganGroupEdit from '@/src/components/admin-area/application-settings/organ-groups/OrganGroupEdit.vue';
import TransplantCentersIndex from '@/src/components/admin-area/transplant_centers/TransplantCentersIndex.vue';
import TransplantCentersEdit from '@/src/components/admin-area/transplant_centers/TransplantCentersEdit.vue';
import SuperTeamDashboardsEdit from '@/src/components/admin-area/super-team-dashboards/SuperTeamDashboardsEdit.vue';
import SuperTeamDashboardsIndex from '@/src/components/admin-area/super-team-dashboards/SuperTeamDashboardsIndex.vue';

import ChecklistTemplateCategoryIndex from '@/src/components/admin-area/checklist/ChecklistTemplateCategoryIndex.vue';
import ChecklistTemplateCategoryEdit from '@/src/components/admin-area/checklist/ChecklistTemplateCategoryEdit.vue';
import ChecklistTemplateIndex from '@/src/components/admin-area/checklist/ChecklistTemplateIndex.vue';
import ChecklistTemplateEdit from '@/src/components/admin-area/checklist/ChecklistTemplateEdit.vue';
import ChecklistEditItem from '@/src/components/admin-area/checklist/ChecklistEditItem.vue';
import ChecklistItemTypeEdit from '@/src/components/admin-area/checklist/ChecklistItemTypeEdit.vue';
import ChecklistItemTypeIndex from '@/src/components/admin-area/checklist/ChecklistItemTypeIndex.vue';

import TagEdit from '@/src/components/admin-area/match-tags/TagEdit.vue'
import TagCategoryIndex from '@/src/components/admin-area/match-tags/TagCategoryIndex.vue'
import TagCategoryEdit from '@/src/components/admin-area/match-tags/TagCategoryEdit.vue'

export function setAdminBreadCrumb() {
  const appStore = useAppCoreStore();
  appStore.setAppBreadcrumbs([
    {
      text: 'Admin Area'
    }
  ]);
}

export const adminRoutes = [
  {
    path: 'admin',
    component: AdminArea,
    beforeEnter: [ setAdminBreadCrumb ],
    children: [
      {
        path: '',
        name: 'admin_root',
        component: AdminDashboard,
        beforeEnter: [ setAdminBreadCrumb ],
        meta: {
          permissions: [PermissionNames.AREA_ADMIN]
        }
      },
      {
        path: 'dashboard',
        name: 'admin_dashboard',
        component: AdminDashboard,
        beforeEnter: [ setAdminBreadCrumb ],
        meta: {
          permissions: [PermissionNames.AREA_ADMIN]
        }
      },
      {
        path: 'teams',
        children: [
          {
            path: '',
            name: PermissionNames.ADMIN_TEAMS,
            component: TeamIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TEAMS]
            }
          },
          {
            path: 'new',
            name: 'admin_teams_new',
            component: TeamEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TEAMS],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_teams_edit',
            component: TeamEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TEAMS],
              permissionsKey: 'write'
            }
          },
          {
            path: ':id/manage',
            name: 'admin_teams_edit_manage',
            component: TeamEditManage,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TEAMS],
              permissionsKey: 'write'
              
            }
          },
          {
            path: ':id/advanced',
            name: 'admin_teams_edit_advanced',
            component: TeamEditAdvanced,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TEAMS],
              permissionsKey: 'write'
            }
          },
          {
            path: ':id/groups',
            name: 'admin_teams_edit_groups_index',
            component: ManageGroupIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TEAMS]
            }
          },
          {
            path: ':id/groups/new',
            name: 'admin_teams_edit_groups_new',
            component: ManageGroupEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TEAMS],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id/groups/:group_id',
            name: 'admin_teams_edit_groups_edit',
            component: ManageGroupEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TEAMS],
              permissionsKey: 'write'
            }
          }
        ]
      },
      {
        path: 'transplant-centers',
        children: [
          {
            path: '',
            name: 'admin_transplant_centers',
            component: TransplantCentersIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TRANSPLANT_CENTER_CONFIGURATIONS]
            }
          },
          {
            path: 'new',
            name: 'admin_transplant_centers_new',
            component: TransplantCentersEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TRANSPLANT_CENTER_CONFIGURATIONS],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_transplant_centers_edit',
            component: TransplantCentersEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TRANSPLANT_CENTER_CONFIGURATIONS],
              permissionsKey: 'write'
            }
          }
        ]
      },
       {
        path: 'super-team-dashboards',
        children: [
          {
            path: '',
            name: 'admin_super_team_dashboards',
            component: SuperTeamDashboardsIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_DASHBOARD_CONFIGURATIONS_INTERNAL_SUPER_TEAM]
            }
          },
          {
            path: 'new',
            name: 'admin_super-team-dashboards_new',
            component: SuperTeamDashboardsEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_DASHBOARD_CONFIGURATIONS_INTERNAL_SUPER_TEAM],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_super-team-dashboards_edit',
            component: SuperTeamDashboardsEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_DASHBOARD_CONFIGURATIONS_INTERNAL_SUPER_TEAM],
              permissionsKey: 'write'
            }
          }
        ]
      },
      {
        path: 'users',
        children: [
          {
            path: '',
            name: 'admin_users',
            component: UserIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_USERS]
            }
          },
          {
            path: 'new',
            name: 'admin_users_new',
            component: UserEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_USERS],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_users_edit',
            component: UserEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_USERS],
              permissionsKey: 'write'
            }
          },
          {
            path: ':id/teams',
            name: 'admin_users_edit_teams',
            component: UserEditTeams,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_USERS],
              permissionsKey: 'write'
            }
          },
          {
            path: ':id/advanced',
            name: 'admin_users_edit_advanced',
            component: UserEditAdvanced,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_USERS],
              permissionsKey: 'write'
            }
          },
        ],
      },
      {
        path: 'import_users',
        name: 'admin_mass_import_users',
        component: ImportUsers,
        beforeEnter: [ setAdminBreadCrumb ],
        meta: {
          permissions: [PermissionNames.ADMIN_USERS_MASS_IMPORT]
        }
      },
      {
        path: 'roles',
        children: [
          {
            path: '',
            name: 'admin_roles',
            component: RoleIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_ROLES]
            }
          },
          {
            path: 'new',
            name: 'admin_roles_new',
            component: RoleEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_ROLES],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_roles_edit',
            component: RoleEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_ROLES],
              permissionsKey: 'write'
            }
          }
        ]
      },
      {
        path: 'membership-categories',
        children: [
          {
            path: '',
            name: 'membership_categories',
            component: MembershipCategoryIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TEAMS]
            }
          },
          {
            path: 'new',
            name: 'membership_categories_new',
            component: MembershipCategoryEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_MEMBERSHIP_CATEGORIES],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'membership_categories_edit',
            component: MembershipCategoryEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_MEMBERSHIP_CATEGORIES],
              permissionsKey: 'write'
            }
          },
        ],
      },
      {
        path: 'template-categories',
        children: [
          {
            path: '',
            name: 'admin_communication_template_categories',
            component: TemplateCategoryIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_MEMBERSHIP_CATEGORIES]
            }
          },
          {
            path: 'new',
            name: 'admin_communication_template_categories_new',
            component: TemplateCategoryEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_MEMBERSHIP_CATEGORIES],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_communication_template_categories_edit',
            component: TemplateCategoryEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_MEMBERSHIP_CATEGORIES],
              permissionsKey: 'write'
            }
          },
          {
            path: ':id/advanced',
            name: 'admin_communication_template_categories_edit_advanced',
            component: TemplateCategoryEditAdvanced,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_MEMBERSHIP_CATEGORIES],
              permissionsKey: 'write'
            }
          }
        ]
      },
      {
        path: 'templates',
        children: [
          {
            path: '',
            name: 'admin_communication_templates',
            component: TemplateIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_COMMUNICATION_TEMPLATES]
            }
          },
          {
            path: 'new',
            name: 'admin_communication_template_new',
            component: TemplateEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_COMMUNICATION_TEMPLATES],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_communication_template_edit',
            component: TemplateEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_COMMUNICATION_TEMPLATES],
              permissionsKey: 'write'
            }
          },
          {
            path: ':id/advanced',
            name: 'admin_communication_template_edit_advanced',
            component: TemplateEditAdvanced,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_COMMUNICATION_TEMPLATES],
              permissionsKey: 'write'
            }
          }
        ]
      },
      {
        path: 'match',
        children: [
          {
            path: 'checklists',
            children: [
              {
                path: 'template-categories',
                children: [
                  {
                    path: '',
                    name: 'admin_checklist_template_categories',
                    component: ChecklistTemplateCategoryIndex,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS]
                    }
                  },
                  {
                    path: 'new',
                    name: 'admin_checklist_template_categories_new',
                    component: ChecklistTemplateCategoryEdit,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS],
                      permissionsKey: 'create'
                    }
                  },
                  {
                    path: ':id',
                    name: 'admin_checklist_template_categories_edit',
                    component: ChecklistTemplateCategoryEdit,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS],
                      permissionsKey: 'write'
                    }
                  }
                ]
              },
              {
                path: 'templates',
                children: [
                  {
                    path: '',
                    name: 'admin_checklist_templates',
                    component: ChecklistTemplateIndex,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS]
                    }
                  },
                  {
                    path: 'new',
                    name: 'admin_checklist_templates_new',
                    component: ChecklistTemplateEdit,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS],
                      permissionsKey: 'create'
                    }
                  },
                  {
                    path: ':id',
                    children: [
                      {
                        path: '',
                        name: 'admin_checklist_templates_edit',
                        component: ChecklistTemplateEdit,
                        beforeEnter: [ setAdminBreadCrumb ],
                        meta: {
                          permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS],
                          permissionsKey: 'write'
                        }
                      },
                      {
                        path: 'items',
                        name: 'admin_checklist_templates_edit_item',
                        component: ChecklistEditItem,
                        beforeEnter: [ setAdminBreadCrumb ],
                        meta: {
                          permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS],
                          permissionsKey: 'write'
                          
                        }
                      }
                    ]
                  },
                ]
              },
              {
                path: 'checklist-item-types',
                children: [
                  {
                    path: '',
                    name: 'admin_checklist_item_types',
                    component: ChecklistItemTypeIndex,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS]
                    }
                  },
                  {
                    path: 'new',
                    name: 'admin_checklist_item_types_new',
                    component: ChecklistItemTypeEdit,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS],
                      permissionsKey: 'create'
                    }
                  },
                  {
                    path: ':id',
                    name: 'admin_checklist_item_types_edit',
                    component: ChecklistItemTypeEdit,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_CHECKLISTS],
                      permissionsKey: 'write'
                    }
                  }
                ]
              }
            ]
          },
          {
            path: 'tag-categories',
            children: [
               {
                path: '',
                children: [
                  {
                    path: '',
                    name: 'admin_tag_categories',
                    component: TagCategoryIndex,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_TAGS]
                    }
                  },
                  {
                    path: 'new',
                    name: 'admin_tag_categories_new',
                    component: TagCategoryEdit,
                    beforeEnter: [ setAdminBreadCrumb ],
                    meta: {
                      permissions: [PermissionNames.ADMIN_MATCH_TAGS],
                      permissionsKey: 'create'
                    }
                  },
                  {
                    path: ':id',
                    children: [
                      {
                        path: '',
                        name: 'admin_tag_categories_edit',
                        component: TagCategoryEdit,
                        beforeEnter: [ setAdminBreadCrumb ],
                        meta: {
                          permissions: [PermissionNames.ADMIN_MATCH_TAGS],
                          permissionsKey: 'write'
                        }
                      },
                      {
                        path: 'tags',
                        name: 'admin_tag_categories_edit_tags',
                        component: TagEdit,
                        beforeEnter: [ setAdminBreadCrumb ],
                        meta: {
                          permissions: [PermissionNames.ADMIN_MATCH_TAGS],
                          permissionsKey: 'write'
                          
                        }
                      },
                      {
                        path: 'tags/:id',
                        name: 'admin_tags_edit',
                        component: TagEdit,
                        beforeEnter: [ setAdminBreadCrumb ],
                        meta: {
                          permissions: [PermissionNames.ADMIN_MATCH_TAGS],
                          permissionsKey: 'write'
                        }
                      }
                    ]
                  },
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'aro-rules',
        children: [
          {
            path: '',
            name: 'admin_aro_rules',
            component: ARORulesIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: PermissionNames.ADMIN_ARO_RULES
            }
          },
          {
            path: 'new',
            name: 'admin_aro_rules_new',
            component: ARORulesEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: PermissionNames.ADMIN_ARO_RULES,
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_aro_rules_edit',
            component: ARORulesEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: PermissionNames.ADMIN_ARO_RULES,
              permissionsKey: 'write'
            }
          }
        ]
      },
      {
        path: 'application_configurations',
        children: [
          {
            path: 'robocall_reduction',
            name: 'admin_configurations_robocall_reduction',
            component: RobocallReductionsEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_CONFIGURATIONS_ROBOCALL_REDUCTION]
            }
          },
          {
            path: 'robocall_reduction_notifications',
            name: 'admin_robocall_reduction_notifications',
            component: ManageRobocallNotifications,
            beforeEnter: [setAdminBreadCrumb],
            meta: {
              permissions: [PermissionNames.ADMIN_CONFIGURATIONS_ROBOCALL_REDUCTION]
            }
          },
          {
            path: 'organs',
            children: [
              {
                path: '',
                name: 'admin_organs',
                component: OrganIndex,
                beforeEnter: [ setAdminBreadCrumb ],
                meta: {
                  permissions: [PermissionNames.ADMIN_ORGAN_AND_ORGAN_GROUPS]
                }
              }
            ],
          },
          {
            path: 'organ-groups',
            children: [
              {
                path: '',
                name: 'admin_organ_groups',
                component: OrganGroupIndex,
                beforeEnter: [ setAdminBreadCrumb ],
                meta: {
                  permissions: [PermissionNames.ADMIN_ORGAN_AND_ORGAN_GROUPS]
                }
              },
              {
                path: 'new',
                name: 'admin_organ_groups_new',
                component: OrganGroupEdit,
                beforeEnter: [ setAdminBreadCrumb ],
                meta: {
                  permissions: [PermissionNames.ADMIN_ORGAN_AND_ORGAN_GROUPS],
                  permissionsKey: 'create'
                }
              },
              {
                path: ':id',
                name: 'admin_organ_groups_edit',
                component: OrganGroupEdit,
                beforeEnter: [ setAdminBreadCrumb ],
                meta: {
                  permissions: [PermissionNames.ADMIN_ORGAN_AND_ORGAN_GROUPS],
                  permissionsKey: 'write'
                }
              }
            ],
          },
        ]
      },
      {
        path: 'procedure-notes',
        children: [
          {
            path: '',
            name: 'admin_procedure_notes',
            component: ProcedureNotesIndex,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_PROCEDURE_NOTES]
            }
          },
          {
            path: 'new',
            name: 'admin_procedure_notes_new',
            component: ProcedureNotesEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_PROCEDURE_NOTES],
              permissionsKey: 'create'
            }
          },
          {
            path: ':id',
            name: 'admin_procedure_notes_edit',
            component: ProcedureNotesEdit,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_PROCEDURE_NOTES],
              permissionsKey: 'write'
            }
          }
        ]
      },
      {
        path: 'troubleshoot',
        children: [
          {
            path: 'donors',
            name: 'admin_troubleshoot_donors',
            component: TroubleshootDonors,
            beforeEnter: [ setAdminBreadCrumb ],
            meta: {
              permissions: [PermissionNames.ADMIN_TROUBLESHOOT_DONORS]
            }
          },
          {
            path: 'matches',
            name: 'admin_troubleshoot_matches',
            component: TroubleshootMatches,
            beforeEnter: [setAdminBreadCrumb],
            meta: {
              permissions: [PermissionNames.ADMIN_TROUBLESHOOT_MATCHES]
            }
          },
          {
            path: 'robocall-reduction',
            name: 'admin_troubleshoot_robocall_reduction',
            component: TroubleshootRobocallReduction,
            beforeEnter: [setAdminBreadCrumb],
            meta: {
              permissions: [PermissionNames.ADMIN_TROUBLESHOOT_ROBOCALL_REDUCTION]
            }
          }        
        ]
      },
      ...adminIntegrationRoutes,
      ...adminFinalizedOffersCSVRoutes
    ]
  },
]